/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useState } from 'react'

import { Button, Col, Form, Input, PageHeader, Radio, Row, Table } from 'antd'
import { MaskedInput } from 'antd-mask-input'
import ID_COMPONENTE from 'config/idComponente'
import { useExportReport } from 'Hooks/useExportReport'
import cpf from 'Hooks/useMask/cpf'
import Motorista from 'Models/cadastros/Motorista'
import { useNavigate } from 'react-router-dom'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import WsCadastroService from 'Services/WS_CADASTRO'
import { ServiceListResponse } from 'Types/ServiceResponse'

import IFormMotoristasFilter from './IFormMotoristasFilter'

const ListMotoristas: FC = () => {
  const navigate = useNavigate()
  const [dataItens, setDataItens] = useState<
    ServiceListResponse<Motorista> | undefined
  >()
  const [carregandoPesquisa, setCarregandoPesquisa] = useState<boolean>(false)
  const [carregandoExportacao, setCarregandoExportacao] =
    useState<boolean>(false)
  const [formulario] = Form.useForm<IFormMotoristasFilter>()
  const [alturaTabela, setAlturaTabela] = useState<number>(
    window.innerHeight - 425,
  )

  window.addEventListener('resize', () =>
    setAlturaTabela(window.innerHeight - 425),
  )

  const colunas = [
    {
      title: 'Nome',
      key: 'nome',
      dataIndex: 'nome',
      render: (nome: string, motorista: Motorista) =>
        nome + (motorista.sobrenome ? ' ' + motorista.sobrenome : ''),
    },
    {
      title: 'CPF',
      key: 'cpf',
      dataIndex: 'cpf',
    },
    {
      title: 'Telefone',
      key: 'telefone',
      dataIndex: 'telefone',
      render: (telefone: string, motorista: Motorista) =>
        (motorista.ddd ? '(' + motorista.ddd + ') ' : '') +
        (telefone ? telefone : ''),
    },
    {
      title: 'Rádio',
      key: 'nextel',
      dataIndex: 'nextel',
    },
    {
      title: 'RFID',
      key: 'rfid',
      dataIndex: 'rfid',
    },
    {
      title: 'Código',
      key: 'codigoMotorista',
      dataIndex: 'codigoMotorista',
    },
    {
      title: 'Situação',
      key: 'ativo',
      dataIndex: 'ativo',
      render: (ativo: boolean) => (ativo ? 'ATIVO' : 'INATIVO'),
    },
  ]

  const pesquisaOuExportaMotoristas = async (
    filtros: IFormMotoristasFilter,
  ) => {
    if (filtros.cpf) {
      filtros.cpf = cpf.clean(filtros.cpf).toString()
    }

    if (filtros.ativo === undefined) {
      filtros.ativo = true
    }

    if (carregandoPesquisa) {
      const { data } = await WsCadastroService.motoristas.getList(
        ID_COMPONENTE.DOCAS,
        filtros,
      )
      setDataItens(data)
      setCarregandoPesquisa(false)
    } else {
      //await useExportReport.exportXLSX(WsCadastroService.motoristas.export, 'Motoristas', colunas, filtros)
      const colunasParaExportar =
        useExportReport.convertColumnToItemsList(colunas)
      const { data } = await WsCadastroService.motoristas.export(
        ID_COMPONENTE.DOCAS,
        filtros,
        undefined,
        { exportItemsList: colunasParaExportar },
      )

      if (data) {
        const a: any = document.createElement('A')
        a.href =
          'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; base64,' +
          data
        a.download = 'Motoristas.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }

      setCarregandoExportacao(false)
    }
  }

  const handleRowClick = (rowData?: Motorista) => {
    navigate('/Motorista/Alterar/' + rowData?.id)
  }

  const alteraPagina = async (numeroPagina: number, tamanhoPagina?: number) => {
    const parametros: ParamsRequest = {
      pageNumber: numeroPagina,
      pageSize: tamanhoPagina ?? 50,
    }

    const { data } = await WsCadastroService.motoristas.getList(
      ID_COMPONENTE.DOCAS,
      formulario.getFieldsValue(),
      parametros,
    )
    setDataItens(data)
  }

  return (
    <>
      <Form
        onFinish={pesquisaOuExportaMotoristas}
        layout="vertical"
        form={formulario}
      >
        <PageHeader
          ghost={false}
          title="Consultar Motorista"
          extra={[
            <Button
              key="pesquisa"
              type="primary"
              htmlType="submit"
              loading={carregandoPesquisa}
              onClick={() => setCarregandoPesquisa(true)}
            >
              Pesquisar
            </Button>,

            <Button
              key="exportacao"
              type="primary"
              htmlType="submit"
              loading={carregandoExportacao}
              onClick={() => setCarregandoExportacao(true)}
            >
              Exportar
            </Button>,

            <Button
              key="inclusao"
              type="primary"
              onClick={() => navigate('/Motorista/Incluir')}
            >
              Incluir
            </Button>,

            <Button key="ajuda" type="primary">
              ?
            </Button>,
          ]}
        >
          <Row gutter={16}>
            <Col span={8} md={8} sm={12} xs={24}>
              <Form.Item name="nome" label="Nome:">
                <Input type="text" />
              </Form.Item>
            </Col>

            <Col span={8} md={8} sm={12} xs={24}>
              <Form.Item name="sobrenome" label="Sobrenome:">
                <Input type="text" />
              </Form.Item>
            </Col>

            <Col span={8} md={8} sm={12} xs={24}>
              <Form.Item name="codigoMotorista" label="Código:">
                <Input type="text" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8} md={8} sm={12} xs={24}>
              <Form.Item name="cpf" label="CPF:">
                <MaskedInput mask="111.111.111-11" />
              </Form.Item>
            </Col>

            <Col span={8} md={8} sm={12} xs={24}>
              <Form.Item name="ativo" label="Situação:">
                <Radio.Group defaultValue={true}>
                  <Radio value={true}>Ativo</Radio>
                  <Radio value={false}>Inativo</Radio>
                  <Radio value={null}>Ambos</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Table
                columns={colunas}
                dataSource={dataItens?.items || []}
                scroll={{ y: alturaTabela }}
                onRow={(rowData: Motorista) => {
                  return {
                    onClick: () => handleRowClick(rowData),
                  }
                }}
                pagination={{
                  pageSize: dataItens?.pagination?.pageSize,
                  total: dataItens?.pagination?.total,
                  onChange: alteraPagina,
                  onShowSizeChange: alteraPagina,
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '25', '50', '75', '100'],
                  size: 'default',
                }}
              />
            </Col>
          </Row>
        </PageHeader>
      </Form>
    </>
  )
}

export default ListMotoristas
